import React from 'react';

import { Icon, Popup } from 'semantic-ui-react';

import { BasicViewHeader } from '../../components';

const tooltipContent = `This view shows path to conversion with two touch points or more.
Including a middle touchpoint filter will only display conversions with three or more touchpoints.
Paths displayed would be adjusted by touchpoint filters.`;

export const MainHeader = () => (
  <BasicViewHeader
    header="Funnel Position"
    subheader={(
      <>
        View your overall marketing performance using various funnel positions
        <Popup basic inverted content={tooltipContent} trigger={<Icon name="question circle" className="tooltip-icon" style={{ color: '#bfc6f3' }} />} />
      </>
    )}
  />
);
